import { render } from "./AddUserManagement.vue?vue&type=template&id=0748a02f"
import script from "./AddUserManagement.vue?vue&type=script&lang=js"
export * from "./AddUserManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__